import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface LinkItemsTRPCInput {
  Source: string;
  Targets: string[];
}

export const useLinkItemsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.linkedItem.link.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.linkedItem.linkedItems.queryKey(),
        });
      },
    }),
  });
  const linkItems = async (input: LinkItemsTRPCInput) => {
    await mutation.mutateAsync(input);
  };

  return {
    linkItems,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
